export const SHARED_TRANSITION_WATCH_ROUTE_NAME = 'watch-kinopoiskId'

export const SHARED_TRANSITION_MORPH_INTENT_TTL_MS = 1200

export const SHARED_TRANSITION_MORPH_LANDING_TIMEOUT_MS = 8000

export const SHARED_TRANSITION_MORPH_LIFT_MS = 260

export const SHARED_TRANSITION_MORPH_FLIGHT_MS = 620

export const SHARED_TRANSITION_MORPH_FADE_MS = 320

export const SHARED_TRANSITION_EASING_EMPHASIZED = 'cubic-bezier(0.2, 0, 0, 1)'

export const SHARED_TRANSITION_EASING_SPRING = 'cubic-bezier(0.34, 1.4, 0.64, 1)'
